import { createContext, useMemo } from "react";
import { Game } from "../utilities/utilities";
export const gameContext = createContext(null);

export const GameProvider = ({ children }) => {
  const gameOne = useMemo(() => {
    // Provide default parameters for the Game constructor
    return new Game(
      () => {}, // renderPlayersUi
      () => {}, // renderGameResult
      () => {}, // renderMenuOverlay
      () => {}, // setShowGamePadState
      20, // boardRows
      10, // boardColumns
      30, // speed
      {
        // userSavedData with default settings
        settings: {
          showTouchControls: true,
          controls: {
            controller: [
              {}, // Player 0 controller bindings
              {}, // Player 1 controller bindings
              {}, // Player 2 controller bindings
              {}, // Player 3 controller bindings
            ],
            touch: {}, // Touch control bindings
            keyBoard: {}, // Keyboard control bindings
          },
        },
      }
    );
  }, []);
  return (
    <gameContext.Provider value={gameOne}>{children}</gameContext.Provider>
  );
};
